import { FormControl, FormMessage, FormField, FormItem } from '@ui/components';
import { FieldValues, Control, Path } from 'react-hook-form';
import { cn } from '@ui/utils';

import { TableListProps, TableList } from './table-list';
import { UseTableList } from './use-table-list';

interface FormTableListProps<T extends FieldValues = FieldValues, D = unknown>
  extends UseTableList<D> {
  text: TableListProps<D>['text'];
  hideErrorMessage?: boolean;
  formControl: Control<T>;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  name: Path<T>;
}

export function FormTableList<T extends FieldValues, D = unknown>({
  hideErrorMessage,
  formControl,
  className,
  isLoading,
  disabled,
  getRowId,
  table,
  text,
  name,
}: FormTableListProps<T, D>) {
  return (
    <FormField
      render={({ field }) => {
        return (
          <FormItem className={cn('relative z-0', className)}>
            <FormControl>
              <TableList
                onSelectedChange={(value) => {
                  field.onChange(value);
                }}
                selected={field.value}
                isLoading={isLoading}
                disabled={disabled}
                getRowId={getRowId}
                table={table}
                text={text}
              />
            </FormControl>
            {!hideErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
      control={formControl}
      name={name}
    />
  );
}
